import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'
import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import { ApiLogsDao } from '@/interfaces/system-log/ApiLogs.dao'
import { MarketplaceFeedsDao } from '@/interfaces/system-log/MarketplaceFeeds.dao'
import { MarketplaceFeedRequestTypesDao } from '@/interfaces/system-log/MarketplaceFeedRequestTypes.dao'
import { StockUpdateLogsDao } from '@/interfaces/system-log/StockUpdateLogs.dao'
import { LambdaLogsDao } from '@/interfaces/system-log/LambdaLogs.dao'

export default class SystemLogsService extends ApiService {
    async getApiLogs(params?: IRequestParameters): Promise<[ApiLogsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [ApiLogsDao[], PageNumberPagination]>(
            'GET',
            '/api-logs',
            params,
            undefined,
            undefined,
            'getApiLogs',
        ).catch(() => null)
    }
    async getLambdaLogs(params?: IRequestParameters): Promise<[LambdaLogsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [LambdaLogsDao[], PageNumberPagination]>(
            'GET',
            '/api-logs/lambda-logs',
            params,
            undefined,
            undefined,
            'getLambdaLogs',
        ).catch(() => null)
    }

    async getMarketplaceFeeds(
        params?: IRequestParameters,
    ): Promise<[MarketplaceFeedsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [MarketplaceFeedsDao[], PageNumberPagination]>(
            'GET',
            '/marketplace-feeds',
            params,
            undefined,
            undefined,
            'getMarketplaceFeeds',
        ).catch(() => null)
    }

    async getStockUpdateLogs(
        params?: IRequestParameters,
    ): Promise<[StockUpdateLogsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [StockUpdateLogsDao[], PageNumberPagination]>(
            'GET',
            '/stock-update-logs',
            params,
            undefined,
            undefined,
            'getStockUpdateLogs',
        ).catch(() => null)
    }

    async getApiLogsRequestResponseDetails(
        id: number,
    ): Promise<{ requestDetails: string; responseDetails: string } | null> {
        return this.request<undefined, { requestDetails: string; responseDetails: string }>(
            'GET',
            `/api-logs/${id}/request-response-details`,
            undefined,
            undefined,
            undefined,
            'getApiLogsRequestResponseDetails',
        ).catch(() => null)
    }

    async getMarketplaceFeedsRequestResponseDetails(
        id: number,
    ): Promise<{ requestDetails: string; responseDetails: string } | null> {
        return this.request<undefined, { requestDetails: string; responseDetails: string }>(
            'GET',
            `/marketplace-feeds/${id}/request-response-details`,
            undefined,
            undefined,
            undefined,
            'getMarketplaceFeedsRequestResponseDetails',
        ).catch(() => null)
    }

    async getMarketplaceFeedRequestTypes(
        params?: IRequestParameters,
    ): Promise<[MarketplaceFeedRequestTypesDao[], PageNumberPagination] | null> {
        return this.request<undefined, [MarketplaceFeedRequestTypesDao[], PageNumberPagination]>(
            'GET',
            '/marketplace-feeds/request-types',
            params,
            undefined,
            undefined,
            'getMarketplaceFeedRequestTypes',
        ).catch(() => null)
    }

    async getCloudWatchLogGroups(params?: IRequestParameters): Promise<any | null> {
        return this.request<undefined, any>(
            'GET',
            '/cloud-watch/log-groups',
            params,
            undefined,
            undefined,
            'getCloudWatchLogGroups',
        ).catch(() => null)
    }

    async getCloudWatchLogGroupStreams(params?: IRequestParameters): Promise<any | null> {
        return this.request<undefined, any>(
            'GET',
            '/cloud-watch/log-group-streams',
            params,
            undefined,
            undefined,
            'getCloudWatchLogGroupStreams',
        ).catch(() => null)
    }

    async getCloudWatchLogGroupStreamEvents(params?: IRequestParameters): Promise<any | null> {
        return this.request<undefined, any>(
            'GET',
            '/cloud-watch/log-group-stream-events',
            params,
            undefined,
            undefined,
            'getCloudWatchLogGroupStreamEvents',
        ).catch(() => null)
    }

    async filterCloudWatchLogGroupStreamEvents(params?: IRequestParameters): Promise<any | null> {
        return this.request<undefined, any>(
            'GET',
            '/cloud-watch/filter-log-group-stream-events',
            params,
            undefined,
            undefined,
            'filterCloudWatchLogGroupStreamEvents',
        ).catch(() => null)
    }
}
